import { PageOptionsKey } from '../../types/ast';

export const PAGE_OPTION_NAME: PageOptionsKey = 'multi_page_tutorial_settings';
export const OPTION_KEY_SHOW_NEXT_TOP: PageOptionsKey = 'show_next_top';
export const OPTION_KEY_TIME_REQUIRED: PageOptionsKey = 'time_required';
export const LINK_TITLE = 'Next Step';
